import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment/moment';
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    // format of the returned value
    mask: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    // format of the displayed value
    format: {
      type: String,
      default: ''
    },
    weekStart: {
      type: Number,
      default: 0
    },
    dateFilter: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    outlined: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    myValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    firstDayOfWeek: function firstDayOfWeek() {
      if (this.weekStart) return this.weekStart;
      return this.me.settings.weekStart;
    },
    dateFormat: function dateFormat() {
      if (this.format) return this.format;
      return this.me.settings.dateFormat.toUpperCase();
    },
    maskFormat: function maskFormat() {
      return this.mask.toUpperCase();
    },
    inputDateMask: function inputDateMask() {
      return this.dateFormat.replace(/y/gi, '#').replace(/m/gi, '#').replace(/d/gi, '#');
    },
    formattedDate: function formattedDate() {
      return this.formatDate(this.value);
    }
  },
  methods: {
    formatDate: function formatDate(date) {
      return moment(date, this.maskFormat).format(this.dateFormat);
    }
  }
};